import { Component, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/tools/header.service';
import { Language } from '../../../entities/Language';
import { StorageService } from '../../../tools/storage.service';
import { IxellAPIService, TchatService, Tchat, Roles, StatsFeatureType} from 'src/app/tools/api.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Utils } from '../../../tools/utils';

@Component({
  selector: 'app-home-assistance',
  templateUrl: './home-assistance.component.html',
  styleUrls: ['./home-assistance.component.scss']
})
export class HomeAssistanceComponent implements OnInit {

  private langue: Language;
  private langueSub: any;
  language: string;

  Utils = Utils;

  private roleSub: any;
  role: Roles = Roles.Unknown;

  private statsLogFeatureSub: any;

  temp: Tchat = new Tchat;
  url: string;
  urlToken: string;
  urlSafe: SafeResourceUrl;
  token: string;
  flag: number;
  paramTchat: number;// @Caroline -> à supprimer
  isTchat: boolean = false;// @Caroline -> à supprimer

  constructor(private apiService: IxellAPIService, private tchatService: TchatService, private headerService: HeaderService, public sanitizer: DomSanitizer, private storageService: StorageService) { }

  ngOnInit() {
    this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
    this.headerService.changeTitle("support.supportAssistance");
    this.langueSub = this.headerService.currentLangue.subscribe(langue => {
      this.langue = langue;
      this.language = langue;
      this.getParam(); // @Caroline -> à supprimer
    });

    // Pour afficher la flèche de retour
    this.headerService.changeCanBack(true);
  }

  ngOnDestroy() {
    if (this.langueSub != null) this.langueSub.unsubscribe();
    if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
  }

  // Récupération du paramétrage du tchat // @Caroline -> à supprimer
  getParam() {
    this.tchatService.getParamTchat().subscribe(data => {
      if (data) {
        this.paramTchat = data;
        switch (this.paramTchat) {
          case 0: // pas de tchat
            this.isTchat = false;
            break;
          case 1: // seulement les français
            if (this.language == "fr") this.isTchat = true;
            else this.isTchat = false;
            break;
          case 2: // multilingue
            this.isTchat = true;
            break;
          default:
            this.isTchat = false;
            break;
        }
      }
    }, error => {
      console.log(error);
    });
  }

  createConversation() {
    this.statsLogFeatureSub = this.apiService.statsLogFeature(StatsFeatureType.AssistTchat).subscribe(() => {
      if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
    });
    
    this.tchatService.getModuleUrl().subscribe(data => {
      if (data) {
        this.url = data + "?Token=";
        // Récupération des informations de connexion
        if (!sessionStorage.getItem("urlTchat")) {
          // Récupération des informations de connexion
          this.apiService.getConnectionInfos().subscribe(data => {
            this.temp.login = data.login;
            this.temp.pwd = data.pwd;
            this.temp.token = data.token;
            this.temp.firstname = data.firstname;
            this.temp.name = data.name;
            this.temp.unisiteCode = data.unisiteCode;


            this.tchatService.createToken(this.temp, this.language).subscribe(data => {
              if (data) {
                this.token = data;
                this.setUrl(this.token, 1);
                sessionStorage.setItem("urlTchat", this.urlToken);
              }
            }, error => {
              console.log(error);
            });
          });
        }
      }
    });

  }

  // Définition de l'url du module de tchat
  setUrl(token: string, flag: number) {
    this.urlToken = null;
    this.urlToken = this.url + token;
    switch (flag) {
      case 1: this.urlToken += "&IsMinimized=false"; break;
      case 2: this.urlToken += "&IsMinimized=true"; break;
    }
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlToken);
  }
}

